enum RenderMode {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
  Dropdown = 'Dropdown',
}

export default RenderMode;
